import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import AuthService from '../../services/authService';
import { showMsg } from '../../services/library';
import { OTPVERIFY_PAGE_PATH, RESET_PASSWORD_PAGE_PATH } from '../../constants/appPathConst';
import { STORAGE_TOKEN } from '../../constants/storageConst';
import { hasFirstAccessiblePage, performLogout, retrieveAuthToken } from '../../generalUtils/rbacUtils';

const REQ_AUTH = 'auth/';

export const fetchLoginReq = createAsyncThunk(
  `${REQ_AUTH}fetchLoginReq`,
  async (
    { username, password, navigate, handleLayoutSetUserInfo, handleSetAuthToken },
    { rejectWithValue }
  ) => {
    try {
      let errMSG = [];
      if (!username) {
        errMSG.push('Username is required.');
      }
      if (!password) {
        errMSG.push('Password is required.');
      }
      if (errMSG.length > 0) {
        showMsg(errMSG, 'error');
        return false;
      }

      const response = await AuthService.signin({
        username: username,
        password: password
      });
      if (response?.status && response?.data) {
        const authData = response?.data && response?.data.length > 0 ? response.data[0] : null;

        if (authData?.type === 'TOKEN') {
          handleSetAuthToken(authData?.token || null);
          handleLayoutSetUserInfo(authData?.user);
          navigate(hasFirstAccessiblePage());
        } else {
          if (response.type === 'RESET') {
            navigate(`${RESET_PASSWORD_PAGE_PATH}/${response.token}`);
          } else {
            handleLayoutSetUserInfo(authData?.user);
            navigate(OTPVERIFY_PAGE_PATH);
          }
        }
      } else {
        showMsg(response?.errors, 'error');
        return rejectWithValue(response?.errors);
      }
    } catch (error) {
      console.log('fetchLoginReq:- ', error);
      showMsg('Network error. Please refresh the page and try again.', 'error');
      return rejectWithValue(error);
    }
  }
);

const loginSlice = createSlice({
  name: 'auth',
  initialState: {
    // Login
    username: '',
    password: '',
    showPassword: false,
    //
    token: retrieveAuthToken()
  },
  reducers: {
    handleUsername: {
      reducer(state, action) {
        state.username = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handlePassword: {
      reducer(state, action) {
        state.password = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleShowPassword: {
      reducer(state, action) {
        state.showPassword = action.payload;
      },
      prepare(e) {
        return { payload: e };
      }
    },

    //--------------------
    handleAuthLogout: {
      reducer(state, action) {
        performLogout(action.payload);

        state.username = '';
        state.password = '';
        state.showPassword = false;
        state.token = null;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSetAuthToken: {
      reducer(state, action) {
        const token = action.payload;
        localStorage.setItem(STORAGE_TOKEN, token);
        state.token = token;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleSetAuthTokenSession: {
      reducer(state, action) {
        const token = action.payload;
        sessionStorage.setItem(STORAGE_TOKEN, token);
        state.token = token;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    handleFetchAuthToken: {
      reducer(state) {
        state.token = retrieveAuthToken();
      },
      prepare() {
        return { payload: null };
      }
    },
    handleUnSetAuthToken: {
      reducer(state, action) {
        localStorage.removeItem(STORAGE_TOKEN);
        state.token = action.payload;
      },
      prepare() {
        return { payload: null };
      }
    }
  }
});

export const {
  handleUsername,
  handlePassword,
  handleShowPassword,
  //
  handleAuthLogout,
  handleSetAuthToken,
  handleFetchAuthToken,
  handleUnSetAuthToken,
  handleSetAuthTokenSession
} = loginSlice.actions;
export default loginSlice.reducer;
